import { createContext, useContext, useState } from "react";
import { useQuery } from "@tanstack/react-query"; // Import TanStack Query
import { getRequest } from "services/api";
import Swal from "sweetalert2";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";

const MenuActiveContext = createContext();

export const MenuActiveProvider = ({ children }) => {
  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    filters: {}, // ✅ wajib ada ini
  });

  const handleFilterByCategory = (categoryId) => {
    setFilterOptions((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        "categories.id": categoryId,
        // "is_active":"1", // Pastikan hanya mengambil menu aktif
      },
      currentPage: 1, // Reset halaman saat filter berubah
    }));
  };

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    paginate: 20,
    include: "categories",
    ...(filterOptions.filters["categories.id"] && {
      [`filter[categories.id]`]: filterOptions.filters["categories.id"],
    }),
    // Tambahkan filter untuk hanya mengambil menu aktif
    "filter[is_active]": "1", // Pastikan hanya mengambil menu aktif
  });

  // Fetch data menggunakan TanStack Query
  const {
    data: menus,
    error,
    isLoading,
    refetch, // Untuk manual refresh data
  } = useQuery({
    queryKey: ["menus", filterOptions],
    queryFn: async () => {
      const response = await getRequest(`/menu${queryString}`);
      if (!response.success) {
        throw new Error(response.message || "Failed to fetch menus.");
      }
      return response;
    },
    keepPreviousData: true, // Agar tidak berkedip saat berpindah halaman
  });

  // Handle pencarian (Enter untuk submit)
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      if (!e.target.value.trim()) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: "Search input cannot be empty!",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }
      setFilterOptions((prev) => ({
        ...prev,
        search: e.target.value,
        currentPage: 1, // Reset ke halaman pertama setelah pencarian
      }));
    }
  };

  const handlePageChange = (page) => {
    setFilterOptions((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const totalPages = menus?.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage: filterOptions.currentPage,
    onPageChange: handlePageChange,
    visiblePages: 5,
  });

  return (
    <MenuActiveContext.Provider
      value={{
        menus: menus?.data || [],
        isLoading,
        error,
        filterOptions,
        handleSearch,
        handleFilterByCategory, // ⬅️ Tambahkan di sini
        refetchMenu: refetch, // Bisa dipanggil untuk refresh data
        Pagination,
      }}
    >
      {children}
    </MenuActiveContext.Provider>
  );
};

export const useActiveMenu = () => {
  const context = useContext(MenuActiveContext);
  if (!context) {
    throw new Error("useMenu must be used within MenuActiveProvider");
  }
  return context;
};
